export default "__VITE_PUBLIC_ASSET__5c3cf5fd__"